// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/5e405b2bd82a29d40231.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"d1831496f27bda4775ad","179":"ebc96c8f6f1244832ded","180":"9eae27cd5196ae1d448b"}[chunkId] + ".chunk.js";
};